/*
Don't change this file manually.
It is autogenerated by @plone/registry.
Instead, change the "addons" registration in the app.
*/
import plonevoltoSlate from '@plone/volto-slate';

const addonsInfo = [{"name":"@plone/volto-slate","version":"19.0.4","isPublishedPackage":true,"isRegisteredAddon":false,"modulePath":"/app/core/packages/volto-slate/src","hasServerConfig":false,"packageJson":"/app/core/packages/volto-slate/package.json","basePath":"/app/core/packages/volto-slate","tsConfigPaths":null,"addons":[]}];
export { addonsInfo };

const safeWrapper = (func) => (config) => {
  const res = func(config);
  if (typeof res === 'undefined') {
    throw new Error("Configuration function doesn't return config");
  }
  return res;
}

const load = (config) => {
  const addonLoaders = [plonevoltoSlate];
  if(!addonLoaders.every((el) => typeof el === "function")) {
    throw new TypeError(
      'Each addon has to provide a function applying its configuration to the projects configuration.',
    );
  }
  return addonLoaders.reduce((acc, apply) => safeWrapper(apply)(acc), config);
};
export default load;
